import Keycloak from 'keycloak-js';

export const keycloakInstance = new Keycloak({
  realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '',
});

function stripIssuerParam() {
  const { origin, pathname, search, hash } = window.location;

  const searchParams = new URLSearchParams(search);
  const searchChanged = searchParams.has('iss');

  searchParams.delete('iss');

  let cleanHash = hash;
  let hashChanged = false;

  if (hash) {
    const hashParams = new URLSearchParams(hash.slice(1));

    hashChanged = hashParams.has('iss');
    hashParams.delete('iss');

    if (hashChanged) {
      const remainingHash = hashParams.toString();

      cleanHash = remainingHash ? `#${remainingHash}` : '';
    }
  }

  if (!searchChanged && !hashChanged) {
    return;
  }

  const cleanSearch = searchParams.toString();

  const cleanUrl = origin + pathname + (cleanSearch ? `?${cleanSearch}` : '') + cleanHash;

  window.history.replaceState(window.history.state, document.title, cleanUrl);
}

stripIssuerParam();
